import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const useFadeUpAnimation = (fadeUpClassName) => {
  const pageRef = useRef(null);

  useEffect(() => {
    const root = pageRef.current;
    if (!root) return;

    const fadeEls = root.querySelectorAll(`.${fadeUpClassName}`);
    fadeEls.forEach((el) => {
      gsap.set(el, { opacity: 0, y: 60 });
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1.0,
        ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 80%" },
      });
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, [fadeUpClassName]);

  return pageRef;
};

export default useFadeUpAnimation;
